import { useQuery } from '@tanstack/react-query';
export const useNewsYearsQuery = () => {
    return useQuery(['news-years'], async () => {
        try {
            const response = await fetch(`/api/news-years`);
            return await response.json();
        }
        catch (error) {
            return error;
        }
    });
};
